import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import styles from "./Opportunities.module.css";
import { ViewSelectButton } from "../../components/buttons/ViewSelectButton";
import { useNavigate, useParams } from "react-router-dom";
import OpportunitiesTab from './OpportunitiesTab'
import EndingContractsTab from "./EndingContractsTab";
import { isOwner } from "../../app/utils/helpers";
import MobileOpportunitiesView from "./mobile/MobileOpportunitiesView";

export function OpportunitiesView() {

    const dispatch = useDispatch()

    const mounted = useRef(null)
    const navigate = useNavigate()
    const urlParams = useParams()

    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const isMobile = useSelector((state) => state.settings.isMobile)
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const [viewsOptions, setViewOptions] = useState([
        { label: <Langs str='OPPORTUNITIES' />, value: 0 },
    ])
    const [selectedView, setSelectedView] = useState(0)

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
            if (isOwner(userRoleId)) {
                setViewOptions([
                    { label: <Langs str='OPPORTUNITIES' />, value: 0 },
                    { label: <Langs str='ENDING_CONTRACTS' />, value: 1 }
                ])
            }
        }
    })

    useEffect(() => {
        if (urlParams.subView && viewsOptions[urlParams.subView]) {
            setSelectedView(urlParams.subView)
        }
    }, [urlParams])

    const handleViewChange = (view) => {
        if (view != null) {
            let selectedTeamId = selectedTeamsIds[0]
            navigate(`/opportunities/${selectedTeamId}/${view}`)
        }
    }


    const header = (view) => {
        return (
            <div className="topMenu" style={{ height: 'auto' }}>
                <Row>
                    <Col lg={4} xs={12} className="d-flex align-items-center">
                        <span className="headerTitle">
                            {viewsOptions[selectedView].label}
                        </span>
                        {/* {isMobile === 1 && view === 0 && (
                            <ImageButton
                                image={addIcon}
                                imageFocus={addIconFocus}
                                onClick={() => {
                                    setAddOpportunitieModalVisible(true);
                                }}
                                active={true}
                                width={32}
                            />
                        )} */}
                    </Col>
                    <Col
                        lg={4}
                        xs={12}
                        className={
                            isMobile === 1 || isMobile === 3
                                ? "d-flex justify-content-center"
                                : "d-flex justify-content-start mt-2"
                        }
                    >
                        <ViewSelectButton
                            options={viewsOptions}
                            selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
                            onViewChange={handleViewChange}
                        />
                    </Col>
                    {isMobile !== 2 && (
                        <Col
                            lg={4}
                            xs={3}
                            className={
                                isMobile === 1 || isMobile === 3
                                    ? "d-flex justify-content-end"
                                    : "d-flex justify-content-end mt-2"
                            }
                        >
                        </Col>
                    )}
                </Row>
            </div>
        )
    }

    const body = (view) => {
        if (view == 0) {
            return (
                <OpportunitiesTab />
            )
        }
        if (view == 1) {
            return (
                isOwner(userRoleId) && <EndingContractsTab />
            )
        }
    }

    if (isMobile === 2) {
        return <MobileOpportunitiesView />
    }

    return (
        <div>
            {header(selectedView)}
            <div>
                {body(selectedView)}
            </div>
        </div>
    )
}